import { useT } from '@transifex/react';
import { BackToDashboardButton, ErrorPageLayout } from './error-page-layout';

export function NotFoundPage() {
  const t = useT();
  return (
    <ErrorPageLayout
      title={t("We can't find the page you're looking for")}
      description={t('Click the button below to go back to the dashboard.')}
      actions={<BackToDashboardButton />}
      image={<img src="/assets/404.svg" alt={t('404 Not Found')} className="max-w-full" />}
    />
  );
}
